import { Checkbox, HStack, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { MCOption } from './teacher/TeacherMCBlock';

type Props = {
  opt: MCOption;
  i: number;
};

/**
 * Read-only multiple-choice row shown after submit.
 * Used by StudentMCBlock and ReviewMCBlock (same Figma feedback states).
 */
export const MCSubmittedOption = ({ opt, i }: Props): ReactElement => {
  const feedback = getFeedback(opt);

  return (
    <HStack
      width="100%"
      gap="10px"
      px="l"
      py="10px"
      justifyContent="space-between"
      alignItems="center"
      bg={feedback?.bg ?? 'grey.white'}
    >
      <Checkbox.Root
        key={i}
        checked={opt.isChecked}
        readOnly
        colorScheme="green"
        gap=".8rem"
        textStyle="body.m.regular"
        flex="1"
        minWidth={0}
        color="text.primary"
        cursor="default"
      >
        <Checkbox.HiddenInput />
        <Checkbox.Control
          borderColor={opt.isChecked ? 'border.accent' : 'border.default'}
          borderRadius="s"
          width="24px"
          height="24px"
          flexShrink={0}
          _checked={{
            backgroundColor: 'background.accent',
            border: 'none',
            color: 'text.onAccent',
          }}
        />
        <Checkbox.Label textStyle="body.m.regular">{opt.text}</Checkbox.Label>
      </Checkbox.Root>
      {feedback && (
        <Text textStyle="body.m.regular" color={feedback.labelColor} flexShrink={0}>
          {feedback.label}
        </Text>
      )}
    </HStack>
  );
};

type Feedback = {
  bg: string;
  label: string;
  labelColor: string;
};

function getFeedback(opt: MCOption): Feedback | null {
  if (opt.isChecked && !opt.isCorrect) {
    return { bg: 'flashcard.background.red', label: 'Falsch', labelColor: 'text.error' };
  }
  if (opt.isChecked && opt.isCorrect) {
    return { bg: 'tag.background.green', label: 'Richtig', labelColor: 'text.accent' };
  }
  if (!opt.isChecked && opt.isCorrect) {
    return { bg: 'tag.background.yellow', label: 'Fehlt', labelColor: 'yellow.600' };
  }
  return null;
}
